import { Injectable } from '@angular/core';
import { PatientConsultationBlService } from '@services/business-logic/patient-consultation/patient-consultation-bl.service';
import { PatientConsultationListItem } from '@models/data/patient-consultations/PatientConsultationListItem';
import { PatientConsultation } from '@models/data/patient-consultations/PatientConsultation';
import { PatientConsultationFormData } from '@models/data/patient-consultations/interfaces/PatientConsultationFormData';
import { PatientConsultationQueryParams } from '@models/data/patient-consultations/interfaces/PatientConsultationQueryParams';
import { PatientConsultationHttpService } from '../../http/patient-consultation/patient-consultation-http.service';
import { take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { IPatientConsultationCreateData } from '@src/app/shared/models/data/patient-consultations/interfaces/IPatientConsultationCreateData';

@Injectable({
  providedIn: 'root',
})
export class PatientConsultationService {
  constructor(
    private blService: PatientConsultationBlService,
    private consultationHttpService: PatientConsultationHttpService
  ) {}

  async list(
    params: PatientConsultationQueryParams
  ): Promise<PatientConsultationListItem[]> {
    return this.blService.listFromAllTenants(params);
  }

  /// Creates a new consultation note in the null tenant
  async createInNullTenant(
    data: IPatientConsultationCreateData
  ): Promise<PatientConsultation> {
    return firstValueFrom(
      this.consultationHttpService
        .createInNullTenant(data)
        .pipe(take(1))
    ).then((res) => res.body.items);
  }

  /// Gets a list of consultation notes for the input patient created by logged in practitioner
  async getList(patientFmpId: string): Promise<PatientConsultation[]> {
    return firstValueFrom(
      this.consultationHttpService
        .getList(patientFmpId)
        .pipe(take(1))
    ).then((res) => res.body);
  }


  listFromSpecificTenantByPatientId(
    patientFitMedProfileId: string,
    tenantId: string
  ): Promise<PatientConsultationListItem[]> {
    return this.blService.listFromSpecificTenantByPatientId(
      patientFitMedProfileId,
      tenantId
    );
  }

  async listFromSpecificTenant(
    queryParams: PatientConsultationQueryParams,
    tenantId: string
  ): Promise<PatientConsultationListItem[]> {
    return firstValueFrom(
      this.consultationHttpService
        .listFromSpecificTenant(queryParams, tenantId)
        .pipe(take(1))
    ).then((res) => res.body.items);
  }

  async listForRibbonFromSpecificTenant(
    queryParams: PatientConsultationQueryParams,
    tenantId: string
  ): Promise<PatientConsultationListItem[]> {
    return firstValueFrom(
      this.consultationHttpService
        .listRibbonFromSpecificTenant(queryParams, tenantId)
        .pipe(take(1))
    ).then((res) => res.body.items);
  }

  createInTenant(
    formData: PatientConsultationFormData,
    tenantId: string
  ): Promise<PatientConsultation> {
    return this.blService.createInTenant(formData, tenantId);
  }

  updateInTenant(
    patientConsultId: string,
    formData: PatientConsultationFormData,
    tenantId
  ): Promise<PatientConsultation> {
    return this.blService.updateInTenant(patientConsultId, formData, tenantId);
  }
}
